const colors = {
	// colorPrimary: '#aa0027',
	// colorGradient:'#aa0027',
	colorGradient: 'linear-gradient(to left, #00f260, #0575e6)',
	colorGreenGradient: 'linear-gradient(to right, #11998e, #52c234)',
	colorPrimary: '#6dd47e',
	colorSecondary: '#003e6e',
	colorWhite: '#ffffff',
	colorText: '#e7eef8',
	colorGray: '#989898',
	colorLight: 'rgba(0, 0, 0, 0.0375)',
	colorBlack: '#05050B',
	colorLightBlack: '#19191F',
	colorTextDark: '#323232',
	colorDarkBlue: '#4D69FA',
	colorDimBlack: '#35363A',
	colorDimBlack1: 'rgb(53,54,58, 0.95)',
	colorInput: '#F9F9F9',

	primaryBtnColorClass: 'primary-bg-color',

	darkBackground1: '#212121',
	darkBackground2: '#1E1E1E',
	darkBackground3: '#333333',
	darkBackground3Light: 'rgba(0,0,0,0.3)',

	primaryText: '#fafafa',
	secondaryText: '#cccccc',

	borderColor: '#afc6d1',

	topNavbar: '#ffffff',
	searchInputBackground: '#ECF2F6',
	inActiveText: '#8e8e8e',
	warningText: 'rgba(246, 58, 58, 0.7)',

	green: '#04AA6D',
	green1: '#75D55A',
	lightGreen: '#75D55A35',
	warnColor: '#ffa500',

	red: '#d32f2f',
};

export default colors;
